exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anchor input[type=text] {\n  max-width: 4rem;\n  border: none;\n  text-align: center;\n  padding: 6px 0 7px;\n  margin-top: 0.25rem; }\n\n.anchor input[type=number] {\n  max-width: 2rem; }\n", ""]);

// exports
